import React, { useEffect, useState } from "react";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";
import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";
import SaveButton from "../../CommonComponents/SaveButton/SaveButton";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { formatCurrency } from "../../../utils/financialFormatters";

function PaymentsInfo({
  getRedemptionsPending,
  paymentInfo,
  apiRunning,
  currencySymbol,
}) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );
  const totalAmount = paymentInfo.totalAmount;
  const usersAffected = paymentInfo.usersAffected;

  const [isApiRunning, setIsApiRunning] = useState(apiRunning);
  const [isSettling, setIsSettling] = useState(false);
  
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [remainingTxns, setRemainingTxns] = useState(AppStrings.FETCHING);
  const [totalTxns, setTotalTxns] = useState(AppStrings.FETCHING);

  useEffect(() => {
    const ws = new WebSocket(
      `${process.env.REACT_APP_ADMIN_PANEL_WEBSOCKET_BASE_URL}?token=${token?.AccessToken}`
    );

    ws.onopen = () => {
      console.log("WebSocket connected");
    };

    ws.onmessage = (message) => {
      const data = JSON.parse(message.data);
      if (data?.event_type === "low_fbo_tx_count") {
        if (
          data?.data?.current_processing_txn === data?.data?.total_txn
        ) {
          setIsSettling(false);
          setSuccessMessage(AppStrings.PAYOUT_COMPLETED);
          getRedemptionsPending();
        }

        handleTriggerPayout();
        setRemainingTxns(data?.data?.remaining_txn);
        setTotalTxns(data?.data?.total_txn);
      }
    };

    ws.onerror = (error) => {
      console.log("WebSocket error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket connection closed");
    };

    return () => {
      ws.close();
    };
  }, [token?.AccessToken]);

  const handleTriggerPayout = async () => {
    setSuccessMessage(AppStrings.PAYOUT_INITIATED_THIS_WILL_UPDATE_AUTOMATICALLY);
    setIsSettling(true);
  }

  const payoutUsers = async () => {
    setErrorMessage("");

    try {
       await PrivateAdminPanelInstance?.post(
         API_ROUTES?.PENDING_REDEMPTIONS_TRIGGER
       );

      handleTriggerPayout();
    } catch (error) {
      console.log("error in payout", error);
      setErrorMessage(AppStrings.PAYOUT_FAILED);
    } finally {
      setIsApiRunning(false);
    }
  };

  return (
    <div className="payments-info">
      {isApiRunning ? (
        <RebetLoader height={"100px"} width={"100px"} />
      ) : (
        <>
          {successMessage && (
            <div className="success-message">{successMessage}</div>
          )}
          {errorMessage && <div className="error-message">{errorMessage}</div>}
          {!isSettling && (
            <>
              <div className="stat">
                  <div className="stat-title">{AppStrings.USERS_AFFECTED}</div>
                <div className="stat-value">
                  {usersAffected} {usersAffected > 1 ? "users" : "user"}
                </div>
              </div>
              <div className="stat">
                  <div className="stat-title">{AppStrings.TOTAL_AMOUNT}</div>
                  <div className="stat-value">
                    {formatCurrency(Number(totalAmount ?? 0), currencySymbol, 2)}
                  </div>
              </div>
            </>
          )}
          {isSettling && (
            <>
              <div className="stat">
                  <div className="stat-title">{AppStrings.TOTAL_TRANSACTIONS}</div>
                <div className="stat-value">{totalTxns}</div>
              </div>
              <div className="stat">
                  <div className="stat-title">{AppStrings.REMAINING_TRANSACTIONS}</div>
                <div className="stat-value">{remainingTxns}</div>
              </div>
            </>
          )}
          <SaveButton
            isApiRunning={isSettling}
            callbackFunction={payoutUsers}
              buttonText={AppStrings.PAYOUT_USERS}
            isDisabled={
              Number(usersAffected) === 0 ||
              Number(totalAmount) === 0 ||
              isSettling
            }
          />
        </>
      )}
    </div>
  );
}

export default PaymentsInfo;
